export const languages = [
  { display_name: 'हिन्दी', name: 'Hindi', code: 'hi' },
  { display_name: 'ಕನ್ನಡ', name: 'Kannada', code: 'kn' },
  { display_name: 'বাংলা', name: 'Bengali', code: 'bn' },
  { display_name: 'ગુજરાતી', name: 'Gujarati', code: 'gu' },
  { display_name: 'ଓଡ଼ିଆ', name: 'Odia', code: 'or' },
  { display_name: 'తెలుగు', name: 'Telugu', code: 'te' },
  { display_name: 'தமிழ்', name: 'Tamil', code: 'ta' },
  { display_name: 'മലയാളം', name: 'Malayalam', code: 'ml' },
  { display_name: 'मराठी', name: 'Marathi', code: 'mr' },
  { display_name: 'ਪੰਜਾਬੀ', name: 'Punjabi', code: 'pa' },
  { display_name: 'অসমীয়া', name: 'Assamese', code: 'as' },
];
